module.exports = __webpack_public_path__ + "static/media/465.584ae400.jpg";